const Card = ({ children }) => {
  return (
    <div className="d-flex justify-content-center align-items-center my-1">
      <div className="card px-5 py-2 shadow m-4">{children}</div>
    </div>
  );
};

export default Card;
